import { EVERSE_GITHUB, PROJECT } from './project'
import type { IconName } from './ui/Icon'

/** Where what this dashboard shows comes from. Listed on Welcome and About. */
export const RESOURCES: { icon: IconName; name: string; url: string; what: string }[] = [
  {
    icon: 'tool',
    name: 'resqui',
    url: PROJECT.resquiUrl,
    what: 'The EVERSE quality pipeline. It runs quality tools on a repository and writes the assessment report.',
  },
  {
    icon: 'document',
    name: 'Assessment schema',
    url: PROJECT.schemasUrl,
    what: 'The format of an assessment report.',
  },
  {
    icon: 'table',
    name: 'EVERSE indicators',
    url: `${PROJECT.everse.url}/indicators/website/indicators.html`,
    what: 'Every published indicator and the quality dimensions it belongs to.',
  },
  {
    icon: 'book',
    name: 'RSQKit',
    url: `${PROJECT.everse.url}/RSQKit/`,
    what: 'How to meet the indicators: tasks, tools and training.',
  },
  {
    icon: 'folders',
    name: 'EVERSE Assessment Registry',
    url: `${EVERSE_GITHUB}/AssessmentRegistry`,
    what: 'Published assessments, and the community sources that publish them.',
  },
]
